const isFTSP = process.env.MIX_FACULTY_LABEL === 'FTSP';

export const dokumen = {
    // Daftar laporan yang ditampilkan; FTSP tidak lagi mengunggah berita acara (D008)
    laporan: (laporan) => {
        if (!laporan) return [];
        if (!isFTSP) return laporan;
        return laporan.filter(doc => doc.kode_jenis_dokumen !== 'D008');
    }
};
